import template from './error-404.html';
import controller from './error-404.controller';
import './error-404.scss';

let Error404Component = {
  bindings: {},
  template,
  controller
};

export default Error404Component;



// WEBPACK FOOTER //
// ./src/app/pages/error-404/error-404.component.js